import React from 'react'

export default function LolliPopIcon() {
   return (
      <svg
         width="13"
         height="25"
         viewBox="0 0 13 25"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M12.3792 6.98451C12.3792 3.62003 9.64195 0.882812 6.27748 0.882812C2.913 0.882812 0.175781 3.62003 0.175781 6.98451C0.175781 10.2119 2.69578 12.8547 5.8707 13.0655V24.476C5.8707 24.5839 5.91355 24.6874 5.98984 24.7637C6.06613 24.84 6.16959 24.8828 6.27748 24.8828C6.38536 24.8828 6.48883 24.84 6.56511 24.7637C6.6414 24.6874 6.68426 24.5839 6.68426 24.476V13.0655C9.85917 12.8547 12.3792 10.2119 12.3792 6.98451ZM4.24358 6.98451C3.34622 6.98451 2.61646 6.25474 2.61646 5.35739C2.61646 4.46003 3.34622 3.73027 4.24358 3.73027C5.14093 3.73027 5.8707 4.46003 5.8707 5.35739C5.8707 6.25474 5.14093 6.98451 4.24358 6.98451Z"
            fill="#F1ECDC"
         />
      </svg>
   )
}
